import { Injectable } from '@angular/core';
import { IAlert } from '../models/alert';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject: Subject<IAlert> = new Subject<IAlert>();
  public alert$: Observable<IAlert> = this.alertSubject.asObservable();

  public showAlert(alert: IAlert): void {
    this.alertSubject.next(alert);
  }
}
